import { render } from "./BasicTable.vue?vue&type=template&id=894ac5f4&scoped=true"
import script from "./BasicTable.vue?vue&type=script&lang=js"
export * from "./BasicTable.vue?vue&type=script&lang=js"

import "./BasicTable.vue?vue&type=style&index=0&id=894ac5f4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-894ac5f4"],['__file',"resources/assets/components/Basic/BasicTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "894ac5f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('894ac5f4', __exports__)) {
    api.reload('894ac5f4', __exports__)
  }
  
  module.hot.accept("./BasicTable.vue?vue&type=template&id=894ac5f4&scoped=true", () => {
    api.rerender('894ac5f4', render)
  })

}


export default __exports__